import { useWalletChainId } from '../api/user/useWalletChainId';
import { useAppChainId } from '../api/user/useAppChainId';

export const useActiveWallet = () => {
  const appChainId = useAppChainId();
  const walletChainId = useWalletChainId();

  return Boolean(appChainId && walletChainId);
};
